import { render, staticRenderFns } from "./XcMenu.vue?vue&type=template&id=480e5eed&scoped=true&"
import script from "./XcMenu.vue?vue&type=script&lang=js&"
export * from "./XcMenu.vue?vue&type=script&lang=js&"
import style0 from "./XcMenu.vue?vue&type=style&index=0&id=480e5eed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e5eed",
  null
  
)

export default component.exports